<template>
    <Forms ref="frmSearch"
            title="INFORMAÇÕES"
            :showHelp="false"
            :showClearButton="false"
            :showSearchButton="false"
            :showNewButton="false"
            :ShowFooterImbo="false"
            :showEdit="true"
            style="font-family: 'Segoe UI';"
            >
        <div class="aprDetails">
            <div class="title-container">
                <div class="title-apr">Informações APR</div>
            </div>
            <div v-if="propApr.sincronizacaoCompleta === false" class="sync-warning">
                <i class="fas fa-exclamation-triangle"></i> <strong>Ainda há informações pendentes a serem enviadas do APP</strong>
            </div>
            <div class="information">
                <div class="status">
                    <div class="subtitle">
                        Status
                    </div>
                    <div :class="propApr.statusAPR === 0 ? 'status-pill-waiting' : propApr.statusAPR === 1 ?
                                'status-pill-aproved' : 'status-pill-reproved'">{{ propApr.statusAPRDescricao }}
                    </div>
                </div>
                <div>
                    <div class="subtitle">Revisão</div>
                    <div class="mt-2">{{ propApr.revisao }}</div>
                </div>
                <div>
                    <div class="subtitle">Data APR</div>
                    <div class="mt-2">{{ formatDataHora(propApr.dataExecucaoAPR) || propApr.dataExecucaoFormatada }}</div>
                </div>
                <div>
                    <div class="subtitle">Validade APR</div>
                    <div class="mt-2">{{ propApr.dataValidadeAPRFormatada }}</div>
                </div>
                <div>
                    <div class="subtitle">Obra</div>
                    <div class="mt-2">{{ propApr.refereciaObra }}</div>
                </div>
                <div>
                    <div class="subtitle">Modo</div>
                    <div class="mt-2">{{ propApr.offlineDescricao }}</div>
                </div>
            </div>
            <div>
                <div>
                    <div class="subtitle">Local</div>
                    <div class="mt-2">{{ propApr.local }}</div>
                </div>
            </div>
            <div class="title-apr">Atividade</div>
            <div class="information">
                <div>
                    <div class="subtitle">Área</div>
                    <div class="mt-2">{{ propApr.atividade }}</div>
                </div>
                <div>
                    <div class="subtitle">Descrição Atividade</div>
                    <div class="mt-2">{{ propApr.descricaoAtividade }}</div>
                </div>
            </div>
            <div class="title-apr">Responsável</div>
            <div class="information">
                <div style="width: 50%;">
                    <div class="subtitle">Colaborador</div>
                    <div class="mt-2">{{ propApr.responsavel }}</div>
                </div>
                <div>
                    <div class="subtitle">Matrícula</div>
                    <div class="mt-2">{{ propApr.matricula }}</div>
                </div>
            </div>
            <div class="title-apr">Matriz Análise de Risco</div>
            <div class="information">
                <div class="calculo-toleravel"
                    :style="{backgroundColor: nota === 3 ? '#FFCDCD' : (nota === 2 ? '#FFD8BB' : '#CBE9CF')}">
                        <svg
                            width="37"
                            height="37"
                            viewBox="0 0 37 37"
                            xmlns="http://www.w3.org/2000/svg">
                            <mask id="path-1-inside-1_2667_1733"
                                  fill="white">
                            <path d="M8.28703 1.0773e-05C8.24682 0.000882273 8.20672 0.00467535 8.16707 0.0113568H3.32V0.841357V3.33136H0V8.31136H3.32V9.97136H5.81V28.2314H4.15V29.0614V31.5514H0.83V32.3814V36.5314H15.77V31.5514H12.45V28.2314H10.79V9.97136H14.11V8.31136H26.975V10.4577L24.1413 13.2914H20.75V14.9514H34.86V13.2914H31.4687L28.635 10.4577V8.31136H34.86V3.33136H13.8166C13.1271 1.4049 11.2833 0.0113568 9.13 0.0113568H8.42807C8.38146 0.00356315 8.33427 -0.000229927 8.28703 1.0773e-05ZM4.97999 1.67136H7.46999V6.65136H12.45V7.34194C12.4352 7.43157 12.4352 7.52303 12.45 7.61266V8.31136H10.0994C10.0098 8.29654 9.91832 8.29654 9.82868 8.31136H6.76806C6.72146 8.30356 6.67427 8.29977 6.62703 8.30001C6.58682 8.30088 6.54672 8.30468 6.50707 8.31136H4.98V7.62077C4.99481 7.53114 4.99481 7.43968 4.98 7.35005V4.30077C4.99481 4.21114 4.99481 4.11968 4.98 4.03005L4.97999 1.67136ZM9.12999 1.67136C10.9598 1.67136 12.45 3.16158 12.45 4.99136H9.12999V1.67136ZM1.65999 4.99136H3.31999V6.65136H1.65999V4.99136ZM14.11 4.99136H33.2V6.65136H14.11V5.96077C14.1248 5.87114 14.1248 5.77968 14.11 5.69005V4.99136ZM7.46999 9.97136H9.12999V28.2314H7.46999V9.97136ZM27.805 11.975L29.1213 13.2914H26.4887L27.805 11.975ZM20.75 16.6114V21.5914H19.09V36.5314H36.52V35.7014V24.9114H34.86V16.6114H33.2V18.2714H28.635V16.6114H26.975V18.2714H22.41V16.6114H20.75ZM22.41 19.9314H26.975V21.5914H23.7523H23.24H22.41V19.9314ZM28.635 19.9314H33.2V21.5914H28.635V19.9314ZM20.75 23.2514H22.7277L24.3877 26.5714H34.86V34.8714H20.75V23.2514ZM24.5823 23.2514H26.975V24.9114H25.4123L24.5823 23.2514ZM28.635 23.2514H33.2V24.9114H28.635V23.2514ZM22.41 28.2314V29.8914H24.9V28.2314H22.41ZM26.56 28.2314V29.8914H29.05V28.2314H26.56ZM30.71 28.2314V29.8914H33.2V28.2314H30.71ZM5.80999 29.8914H10.79V31.5514H5.80999V29.8914ZM22.41 31.5514V33.2114H24.9V31.5514H22.41ZM26.56 31.5514V33.2114H29.05V31.5514H26.56ZM30.71 31.5514V33.2114H33.2V31.5514H30.71ZM2.48999 33.2114H4.14999H12.45H14.11V34.8714H2.48999V33.2114Z"/>
                            </mask>
                            <path d="M8.28703 1.0773e-05C8.24682 0.000882273 8.20672 0.00467535 8.16707 0.0113568H3.32V0.841357V3.33136H0V8.31136H3.32V9.97136H5.81V28.2314H4.15V29.0614V31.5514H0.83V32.3814V36.5314H15.77V31.5514H12.45V28.2314H10.79V9.97136H14.11V8.31136H26.975V10.4577L24.1413 13.2914H20.75V14.9514H34.86V13.2914H31.4687L28.635 10.4577V8.31136H34.86V3.33136H13.8166C13.1271 1.4049 11.2833 0.0113568 9.13 0.0113568H8.42807C8.38146 0.00356315 8.33427 -0.000229927 8.28703 1.0773e-05ZM4.97999 1.67136H7.46999V6.65136H12.45V7.34194C12.4352 7.43157 12.4352 7.52303 12.45 7.61266V8.31136H10.0994C10.0098 8.29654 9.91832 8.29654 9.82868 8.31136H6.76806C6.72146 8.30356 6.67427 8.29977 6.62703 8.30001C6.58682 8.30088 6.54672 8.30468 6.50707 8.31136H4.98V7.62077C4.99481 7.53114 4.99481 7.43968 4.98 7.35005V4.30077C4.99481 4.21114 4.99481 4.11968 4.98 4.03005L4.97999 1.67136ZM9.12999 1.67136C10.9598 1.67136 12.45 3.16158 12.45 4.99136H9.12999V1.67136ZM1.65999 4.99136H3.31999V6.65136H1.65999V4.99136ZM14.11 4.99136H33.2V6.65136H14.11V5.96077C14.1248 5.87114 14.1248 5.77968 14.11 5.69005V4.99136ZM7.46999 9.97136H9.12999V28.2314H7.46999V9.97136ZM27.805 11.975L29.1213 13.2914H26.4887L27.805 11.975ZM20.75 16.6114V21.5914H19.09V36.5314H36.52V35.7014V24.9114H34.86V16.6114H33.2V18.2714H28.635V16.6114H26.975V18.2714H22.41V16.6114H20.75ZM22.41 19.9314H26.975V21.5914H23.7523H23.24H22.41V19.9314ZM28.635 19.9314H33.2V21.5914H28.635V19.9314ZM20.75 23.2514H22.7277L24.3877 26.5714H34.86V34.8714H20.75V23.2514ZM24.5823 23.2514H26.975V24.9114H25.4123L24.5823 23.2514ZM28.635 23.2514H33.2V24.9114H28.635V23.2514ZM22.41 28.2314V29.8914H24.9V28.2314H22.41ZM26.56 28.2314V29.8914H29.05V28.2314H26.56ZM30.71 28.2314V29.8914H33.2V28.2314H30.71ZM5.80999 29.8914H10.79V31.5514H5.80999V29.8914ZM22.41 31.5514V33.2114H24.9V31.5514H22.41ZM26.56 31.5514V33.2114H29.05V31.5514H26.56ZM30.71 31.5514V33.2114H33.2V31.5514H30.71ZM2.48999 33.2114H4.14999H12.45H14.11V34.8714H2.48999V33.2114Z"
                                :fill="nota === 3 ? '#D50000' : (nota === 2 ? '#BC4807' : '#1C6228')"
                                stroke="#FFE5E5"
                                stroke-width="0.6"
                                mask="url(#path-1-inside-1_2667_1733)"/>
                        </svg>
                    <div class="calculo-text">
                        <div class="calculo-classficaticao" :style="{ color: nota === 3 ? '#D50000' : (nota === 2 ? '#BC4807' : '#1C6228')}">{{ classificacao }}</div>
                        <!-- <div>Calculo de risco</div> -->
                    </div>
                </div>
            </div>
        </div>
    </Forms>
    </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import { loading } from '@/shared/utils/UIHelper'
import AprAnalisePreliminarRisco from '@/shared/http/repositories/business/aprInquery'

export default {
  name: 'detailsInformation',
  components: {AutocompleteZ},
  mixins: [ ActionsForm, ExpenseMixin ],
  props: ['propApr', 'editDetails'],
  data () {
    return {
      form: {
        ResponsavelId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      AprID: null,
      objApr: null,
      objEdited: null,
      apr: [],
      nota: null,
      classificacao: null
    }
  },
  watch: {
    'editDetails': function (newValue) {
      this.propApr.refereciaObra = newValue.refereciaObra
      this.propApr.local = newValue.local
    }
  },
  mounted () {
    const params = new URLSearchParams(window.location.search)
    params.forEach((value) => {
      this.AprID = value
    })
    loading.push()
    AprAnalisePreliminarRisco.GetTemplate(this.AprID)
      .then((Response) => {
        loading.pop()
        this.apr = Response.data.data
        for (const risco of this.apr) {
          for (const obj of risco.grupo) {
            for (const item of obj.itens) {
              if (item.classificacaoDescricao === 'NT' && (this.nota === null || this.nota <= 3)) {
                this.classificacao = 'Não Tolerável'
                this.nota = 3
              }
              if (item.classificacaoDescricao === 'M' && this.nota < 2) {
                this.classificacao = 'Moderado'
                this.nota = 2
              }
              if (item.classificacaoDescricao === 'T' && this.nota < 1) {
                this.classificacao = 'Tolerável'
                this.nota = 1
              }
            }
          }
          if (this.nota < 1 || this.nota > 3) {
            this.classificacao = null
            this.nota = null
            break
          }
        }
      })
      .catch(Error => {
        loading.pop()
      })
  },
  methods: {
    // Data + hora a partir do datetime cru (propApr.dataExecucaoAPR). Igual ao details.vue —
    // não mexe no campo formatado do backend (dataExecucaoFormatada) usado em relatório.
    formatDataHora (value) {
      if (!value) return ''
      const d = new Date(value)
      if (isNaN(d.getTime())) return ''
      const pad = (n) => String(n).padStart(2, '0')
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    Search () {
    },
    onClearSection () {
    }
  }
}

</script>

<style>
.aprDetails{
    display: flex;
    gap: 1rem;
    flex-direction: column;
    flex-wrap: wrap;
}
.title-container {
    display: flex;
    align-items: center;
}
.title-apr{
    color: #008148;
    font-family: "Segoe UI";
    font-weight: bold;
    font-size: 16px;
}
.sync-warning {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #8B6000;
    font-size: 14px;
    font-family: "Segoe UI";
    padding: 0.75rem;
    background-color: #FFFBE5;
    border-radius: 4px;
    border-left: 4px solid #F6C000;
    margin-bottom: 0.5rem;
}
.information {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    width: 100%;
}
.subtitle{
    width: 100%;
    color: #9AA2A4;
    font-size: 14px;
    font-family: "Segoe UI";
}
.description{
    color: #707070;
    font-size: 14px;
    font-family: "Segoe UI";
    font-weight: bold;
}
.status {
    width: 50%
}
.status-pill-aproved {
    display: flex;
    font-size: 14px !important;
    padding: 1rem;
    width: 12rem;
    height: 30px;
    color: #133B1A;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #CBE9CF;
}
.status-pill-waiting {
    display: flex;
    font-size: 14px !important;
    padding: 1rem;
    width: 12rem;
    height: 30px;
    color: #003789;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #D4EEFD;
}
.status-pill-reproved {
    display: flex;
    font-size: 14px !important;
    padding: 1rem;
    width: 12rem;
    height: 30px;
    color: #AB0101;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #FFD9D9;
}
.calculo-toleravel{
    padding: 1rem;
    width: 100%;
    display: flex;
    border-radius: 15px;
    /* background-color: #FFE6E6; */
    gap: 1rem;
}
.calculo-text{
    gap: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.calculo-classficaticao
{
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
}
@media (min-width: 390px) {
    .status {
        width: 100%;
    }
}

@media (min-width: 1700px) {
    .status {
        width: 50%;
    }
}

@media (min-width: 1700px) {
    .status {
        width: 50%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsInformationApr/inqueryDetailsInformationApr.vue